import actions from './actions'
import mutations from './mutations'

const state = {
  termoBuscaGeralPlataforma: ''
}

const getters = {
  termoBuscaGeralPlataforma: state => state.termoBuscaGeralPlataforma
}

export default {
  state,
  getters,
  mutations,
  actions
}
